// reducers.js
import { combineReducers } from '@reduxjs/toolkit';
import schoolReducer from './slices/schoolSlice';
import superAdminReducer from './slices/SuperAdminSlice';
import vendorReducer from './slices/VendorSlice';
import studentAuthReducer from './slices/StudentAuthSlice';
import teacherReducer from './slices/TeacherSlice';
import { RESET_ALL_AUTH } from './authActions';

const combinedReducer = combineReducers({
  school: schoolReducer,
  superAdmin: superAdminReducer,
  vendor: vendorReducer,
  studentAuth: studentAuthReducer,
  teacher: teacherReducer,
});

/**
 * Handles RESET_ALL_AUTH above the individual slices: passing undefined state
 * makes every slice fall back to its own initialState, so no role can be left
 * behind when another logs in or out.
 */
const rootReducer = (state, action) => {
  if (action.type === RESET_ALL_AUTH) {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

export default rootReducer;
